import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ModernLayout from '../components/modern_layout';
import ModernLoader from '../components/modern_loader';
import ModernOrderSidebar from '../components/modern_order_sidebar';
import { useGlobalToast } from '../components/modern_toast';
import usePageTitle from '../hooks/usePageTitle';
import api from "../services/api";

function ModernPedidosCliente() {
  usePageTitle('Meus Pedidos');
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [pedidos, setPedidos] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { addToast } = useGlobalToast();

    const formatPrice = (price) => {
    if (price === undefined || price === null || price === '') return 'R$ 0,00';
    if (typeof price === 'string') {
      const numericPrice = parseFloat(price.replace(',', '.'));
      if (isNaN(numericPrice)) return 'R$ 0,00';
      return numericPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    if (typeof price === 'number' && !isNaN(price)) {
      return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    return 'R$ 0,00';
  };

  const handleViewDetails = (pedido) => {
    const [dadosPedidoArray, produtosArray] = pedido;
    const dadosPedido = dadosPedidoArray[0];

    setSelectedOrder({
      dados: dadosPedido,
      produtos: produtosArray
    });
    setSidebarOpen(true);
  };

  // Verificação de autenticação e carregamento dos dados
  useEffect(() => {
    // Verificar login
    if (!sessionStorage['login']) {
      window.location.href = '/?id=' + sessionStorage['loja'];
      return;
    }
    
    if (sessionStorage['login'].includes('/')) {
      window.location.href = '/?id=' + sessionStorage['loja'];
      return;
    }

    async function searchPedidos() {
      try {
        setLoading(true);

        const id_loja = sessionStorage['login'];
        let query_start = 0;
        let query_end = 1;
        let produtos_novo = [];
        let break_bool = false;

        while (!break_bool) {
          const resp = await api.post('buscar_meus_pedidos', {
            "login": id_loja,
            "query_start": query_start,
            "query_end": query_end,
          });

          if (resp && resp.data && resp.data.data !== false && Array.isArray(resp.data.data) && resp.data.data.length > 0) {
            let produtos_segundo = [];
            console.log('###Resposta pedidos:');
            console.log(resp.data)
            if (resp.data.produtos && resp.data.produtos.length > 0) {
              for (let produto of resp.data.produtos) {
                console.log('###Produto adicionado:', produto);
                produtos_segundo.push([produto[0], produto[1], produto[2], produto[3]]); // Nome, Imagem, Quantidade, Preço Unitário
              }
            }

            produtos_novo.push([resp.data.data, produtos_segundo]);
            query_start = query_start + 1;
            query_end = query_end + 1;

            // Limite de segurança para evitar loop infinito
            if (query_start >= 20) {
              console.warn('Limite de pedidos atingido (20), parando busca');
              break_bool = true;
            }
          } else {
            break_bool = true;
          }
        }

        setPedidos(produtos_novo);
      } catch (error) {
        console.error('Erro ao carregar pedidos:', error);
        addToast('Erro ao carregar pedidos', 'error');
      } finally {
        setLoading(false);
      }
    }

    // Chamar função de busca com timeout para evitar loop
    const timeoutId = setTimeout(() => {
      searchPedidos();
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [addToast]);

  const formatDate = (dateString) => {
    try {
      if (!dateString) return 'Data não disponível';

      // Tentar criar a data de diferentes formas
      let date;

      // Se a string já contém horário
      if (dateString.includes('T') || dateString.includes(':')) {
        date = new Date(dateString);
      } else {
        // Se for apenas data (dd/mm/yyyy ou yyyy-mm-dd)
        const parts = dateString.includes('/')
          ? dateString.split('/')
          : dateString.split('-');

        if (parts.length === 3) {
          // Assumir formato brasileiro dd/mm/yyyy se contém '/'
          if (dateString.includes('/')) {
            date = new Date(parts[2], parts[1] - 1, parts[0]);
          } else {
            // Formato ISO yyyy-mm-dd
            date = new Date(parts[0], parts[1] - 1, parts[2]);
          }
        } else {
          date = new Date(dateString);
        }
      }

      // Verificar se a data é válida
      if (isNaN(date.getTime())) {
        return dateString;
      }

      return date.toLocaleString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      console.error('Erro ao formatar data:', error, dateString);
      return dateString;
    }
  };

  if (loading) {
    return <ModernLoader message="Carregando pedidos..." />;
  }

  return (
    <ModernLayout title="Meus Pedidos" showBackButton>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            {pedidos.length === 0 ? (
              // Estado vazio
              <div className="text-center py-5">
                <i className="bi bi-bag-x fs-1 text-muted mb-3 d-block"></i>
                <h4>Nenhum pedido encontrado</h4>
                <p className="text-muted mb-4">
                  Você ainda não fez nenhum pedido. Explore nossos produtos!
                </p>
                <button
                  className="btn btn-modern"
                  onClick={() => history.push('/')}
                >
                  <i className="bi bi-cart me-2"></i>
                  Começar a Comprar
                </button>
              </div>
            ) : (
              // Lista de pedidos - Layout compacto e moderno
              <div className="row g-3">
                {pedidos.map((pedido, index) => {
                  const [dadosPedidoArray, produtosArray] = pedido;
                  const dadosPedido = dadosPedidoArray[0];
                  const produtos = produtosArray;

                  return (
                    <div key={index} className="col-12 col-md-6 col-lg-4">
                      <div className="modern-card modern-order-card h-100">
                        {/* Header compacto */}
                        <div className="modern-order-card-header">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div className="flex-grow-1 min-w-0">
                              <h6 className="modern-order-id mb-1" title={dadosPedido[0]}>
                                <i className="bi bi-receipt me-2"></i>
                                Pedido #{typeof dadosPedido[0] === 'string' ? dadosPedido[0].substring(0, 12) : dadosPedido[0]}
                              </h6>
                              <div className="modern-order-date">
                                <i className="bi bi-calendar"></i>
                                <span>{formatDate(dadosPedido[1])}</span>
                              </div>
                              <div className="modern-order-date">
                                <i className="bi bi-cash"></i>
                                <span>Total: {formatPrice(produtos.reduce((total, produto) => total + produto[2] * produto[3], 0).toFixed(2))}</span>
                              </div>
                            </div>
                          </div>

                          {dadosPedido[2] && (
                            <div className="mt-2">
                              <span className="badge bg-warning text-dark">
                                <i className="bi bi-exclamation-triangle me-1"></i>
                                {dadosPedido[2]}
                              </span>
                            </div>
                          )}
                        </div>

                        {/* Body - Resumo */}
                        <div className="modern-order-card-body">
                          {/* Informações resumidas */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="d-flex align-items-center gap-2">
                              <i className="bi bi-box-seam text-primary"></i>
                              <span className="fw-semibold">{produtos.length} {produtos.length === 1 ? 'item' : 'itens'}</span>
                            </div>
                            <span className="modern-order-badge">
                              {produtos.length} produto{produtos.length !== 1 ? 's' : ''}
                            </span>
                          </div>

                          {/* Preview de produtos (máx 3) */}
                          <div className="d-flex gap-2 mb-3 flex-wrap">
                            {produtos.slice(0, 3).map((produto, idx) => (
                              <img
                                key={idx}
                                src={produto[1]}
                                alt={produto[0]}
                                className="rounded"
                                style={{
                                  width: '48px',
                                  height: '48px',
                                  objectFit: 'cover',
                                  border: '2px solid rgba(53, 204, 187, 0.2)'
                                }}
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/48x48/e5e7eb/9ca3af?text=?';
                                }}
                              />
                            ))}
                            {produtos.length > 3 && (
                              <div
                                className="rounded d-flex align-items-center justify-content-center bg-light"
                                style={{
                                  width: '48px',
                                  height: '48px',
                                  border: '2px solid rgba(53, 204, 187, 0.2)'
                                }}
                              >
                                <small className="fw-bold text-muted">+{produtos.length - 3}</small>
                              </div>
                            )}
                          </div>

                          {/* Botão Ver Detalhes */}
                          <button
                            className="btn btn-view-details w-100"
                            onClick={() => handleViewDetails(pedido)}
                          >
                            <i className="bi bi-eye"></i>
                            Ver Detalhes
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Sidebar de detalhes */}
      <ModernOrderSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        pedido={selectedOrder}
      />
    </ModernLayout>
  );
}

export default ModernPedidosCliente;
